import type { TOC } from '@ember/component/template-only';

/** Stands in for a dashboard that can't open here: not a dashboard, or built for another company. */
const DashboardUnavailable: TOC<{ Element: HTMLDivElement }> = <template>
  <div
    class="tio-row-center flex-1 tio-bg-page p-8 tio-type-body-secondary tio-fg-muted"
    data-test-dashboard-view-unavailable
    ...attributes
  >
    This dashboard is not available.
  </div>
</template>;

export default DashboardUnavailable;
